var DataZoomView = require("./DataZoomView");

var _default = DataZoomView.extend({
  type: 'dataZoom.select'
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/_echarts@3.8.5@echarts/lib/component/dataZoom/SelectZoomView.js
// module id = 597
// module chunks = 0